import { gql } from '@apollo/client';

export const FETCH_LMI_PROOF_DOC_LABEL_OPTIONS = gql`
  query Flex_FetchLmiProofDocLabelOptions(
    $utilityId: Int!
    $productId: String
    $category: String!
  ) {
    lmiProofDocLabelOptions(utilityId: $utilityId, productId: $productId, category: $category) {
      data
    }
  }
`;
